import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useContext, useEffect, useState } from 'react';
import { LoginParams, useLogin } from '../../hooks/useLogin';
import { UserContext } from '../../contexts/userContext';
import NuevoUsuario from './NuevoUsuario';
import { IndicatorButton } from '../IndicatorButton';

export default function LoginDialog() {
  const [open, setOpen] = useState(false);
  const [nuevoUsuario, setNuevoUsuario] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [formData, setFormData] = useState<LoginParams>();
  const login = useLogin(formData);

  useEffect(() => {
    if (login.data?._id) {
      setUser(login.data);
      setOpen(false);
    }
  }, [login.data]);

  useEffect(() => {
    const hayUsuario = !!user?.username;
    if (hayUsuario === open ) setOpen(!hayUsuario);
  }, [user]);

  return (
    <div>
      <NuevoUsuario open={nuevoUsuario} onClose={() => setNuevoUsuario(false)} />
      <Dialog open={open}>
        <DialogTitle>Ingresar</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Usuario"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e: any) => {
              setFormData((prevState: any) => ({ ...prevState, username: e.target.value }));
            }}
          />
          <TextField
            autoFocus
            margin="dense"
            id="password"
            label="Contraseña"
            type="password"
            fullWidth
            variant="standard"
            onChange={(e: any) => {
              setFormData((prevState: any) => ({ ...prevState, password: e.target.value }));
            }}
          />
        </DialogContent>
        <DialogActions>
          <IndicatorButton
            onClick={() => setNuevoUsuario(true)}
            loading={login.isLoading}
            label='Registrar Nuevo Usuario'
            size='small'
            variant="outlined"
          />
          <IndicatorButton
            onClick={() => {login.refetch();}}
            loading={login.isLoading}
            disabled={!formData?.password || !formData.username}
            label='Ingresar'
            size='small'
            variant="outlined"
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
